var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutsDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 34,
    viewBox: "0 0 14 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H13C13.5523 0 14 0.447715 14 1V33C14 33.5523 13.5523 34 13 34H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H13C13.5523 0 14 0.447715 14 1V33C14 33.5523 13.5523 34 13 34H0V0Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_120263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2516 15.3672C10.3629 15.3672 10.4464 15.4217 10.502 15.5308C10.5577 15.6398 10.5299 15.7489 10.4464 15.8307L7.66332 18.5569C7.552 18.666 7.38501 18.666 7.27369 18.5569L4.49063 15.8307C4.40713 15.7489 4.3793 15.6398 4.43496 15.5308C4.46279 15.4217 4.57412 15.3672 4.68544 15.3672H10.2516Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_120263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    fill: "white",
    transform: "translate(4 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutsDropdownArrow);
export default __webpack_public_path__ + "static/media/callouts-dropdown-arrow.b698da1ceaad5ac8e1730b7b97891c29.svg";
export { ForwardRef as ReactComponent };